import React from 'react';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { Button } from 'ui-components/components/button';

import { messages, parcelGuardMessages, xCoverMessages } from './messages';
import styles from './walleted-insurance.module.less';
import FormattedCurrency from '../../../../components/formatted-currency';
import HelpArticleLink from '../../../../components/help-article-link';
import { InsuranceProviders } from '../../../../enums/insurance-providers';
import { InsuranceTermsLink } from '../../../../insurance/terms-link';
import { BASE_SHIPMENTS_PATH } from '../../../../routes/constants';
import { linkIDs } from '../../../../services/link-service/links';
import { EventSourceStrings } from '../../../../tracking/tracking-constants';
import { FlexColumn } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';
import { WalletRegistrationOrUpdateButton } from '../../../../wallet/components/wallet-registration-or-update-button';

/**
 * @param {object} props
 * @param {boolean} props.isInsuranceActivated
 * @param {string} props.insuranceProviderId
 * @returns {React.ReactElement}
 */
export const InsuranceCardMain = ({ isInsuranceActivated, insuranceProviderId }) => {
  const carrierMessages = insuranceProviderId === InsuranceProviders.XCover.insuranceProviderId ? xCoverMessages : parcelGuardMessages;
  const claimLinkId =
    insuranceProviderId === InsuranceProviders.XCover.insuranceProviderId ? linkIDs.FileXCoverClaim : linkIDs.FileParcelGuardClaim;

  return (
    <div className={styles['insurance-details']}>
      <Text className={styles['insurance-title']} textType={TextType.H4} value={carrierMessages.insuranceCardTitle} />
      {isInsuranceActivated ? (
        <>
          <Text
            className={styles['insurance-description']}
            textType={TextType.Paragraph}
            value={carrierMessages.insuranceCardDescriptionPostRegistration}
          />
          <FlexColumn className={styles['insurance-help-links']}>
            <InsuranceTermsLink insuranceProviderId={insuranceProviderId} source={EventSourceStrings.INSURANCE_SETTINGS_CONTENT}>
              <Text textType={TextType.Paragraph} value={messages.linksCoverage} />
              <FontAwesomeIcon className={styles['external-link-icon']} icon={faArrowUpRightFromSquare} />
            </InsuranceTermsLink>
            <HelpArticleLink articleId={claimLinkId}>
              <Text textType={TextType.Paragraph} value={messages.linksFileClaim} />
              <FontAwesomeIcon className={styles['external-link-icon']} icon={faArrowUpRightFromSquare} />
            </HelpArticleLink>
            <Link to={BASE_SHIPMENTS_PATH}>
              <Text textType={TextType.Paragraph} value={messages.linksInsuredShipments} />
              <FontAwesomeIcon className={styles['external-link-icon']} icon={faArrowUpRightFromSquare} />
            </Link>
          </FlexColumn>
        </>
      ) : (
        <>
          <div className={styles['insurance-description']}>
            <FormattedCurrency fractionDigits={0} value={10000}>
              {(formattedBalance) => (
                <Text
                  formattedMessageValues={{
                    amount: formattedBalance,
                  }}
                  textType={TextType.Paragraph}
                  value={carrierMessages.insuranceCardDescription}
                />
              )}
            </FormattedCurrency>
          </div>
          <WalletRegistrationOrUpdateButton trackingId={EventSourceStrings.INSURANCE_SETTINGS_CONTENT}>
            {({ openModal }) => (
              <Button className={styles['add-parcelguard-button']} onClick={openModal} theme='primary'>
                <Text textType={TextType.Label} value={carrierMessages.addInsuranceButton} />
              </Button>
            )}
          </WalletRegistrationOrUpdateButton>
        </>
      )}
    </div>
  );
};
